// extracted by mini-css-extract-plugin
export default {"kitchen-component-cell":"yFH9eXSBUrd5pHoDiZsz"};